export enum errorTypes {
    newsItem = 'newsItem',
}

export enum errorKeys {
    itemNotFoundError = 'itemNotFoundError',
    itemsNotFoundError = 'itemsNotFoundError',
    unknownError = 'unknownError',
}
